// extracted by mini-css-extract-plugin
export default {"newTariffButton":"DeletePromoCode-module__newTariffButton--fqq7x"};